import {connect} from 'react-redux'
import React, {Component} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import Navigation from 'apa/containers/Navigation'
import NotFound from 'apa/containers/NotFound'
import {cancelLoad, loadUser} from 'apa/actions'
import {Container} from 'reactstrap'
import {RouteConfig} from 'apa/RouteConfig'
import Loading from 'apa/components/Loading'
import PropTypes from 'prop-types'
import {ConnectedRouter as Router} from 'connected-react-router'
import {history} from 'apa/Storage'
import NetworkDetection from 'apa/containers/NetworkDetection'
import ErrorBoundary from 'apa/containers/ErrorBoundary'
import * as Sentry from '@sentry/react';
import { Integrations as TracingIntegrations } from '@sentry/tracing';

// eslint-disable-next-line no-undef
if(process.env.NODE_ENV === 'production') {
    console.log('init sentry')
    Sentry.init({
        dsn: 'https://be2019cc47cd4ef39bf2021d9767d5c7@sentry.io/1404147',
        integrations: [new TracingIntegrations.BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
            }
        )],
        tracesSampleRate: 0.2
    });
}

@connect(
    state => {
        return {
            isLoading: state.apa.isLoading,
            isAuthenticated: state.apa.isAuthenticated,
            token: state.apa.token,
        }
    },
    dispatch => {
        return {
            loadUser: () => {
                return dispatch(loadUser());
            },
            cancelLoad: () => {
                return dispatch(cancelLoad());
            }
        }
    }
)
export default class RootContainer extends Component {

    static propTypes = {
        isAuthenticated: PropTypes.bool,
        isLoading: PropTypes.bool,
        loadUser: PropTypes.func,
        token: PropTypes.string
    }


    constructor(props) {
        super(props);
        // TODO: move outside
        this.PrivateRoute = ({component: ChildComponent, ...rest}) => {
            return <Route {...rest} render={props => {
                if (this.props.isLoading) {
                    return <Loading/>;
                } else if (!this.props.isAuthenticated) {
                    return <Redirect to='/login/'/>;
                } else {
                    return <ChildComponent {...props} />
                }
            }}/>
        };
    }

    componentDidMount() {
        const {token} = this.props;
        if(token) {
            this.props.loadUser();
        } else {
            this.props.cancelLoad();
        }
    }

    render() {
        let {PrivateRoute} = this;
        return (
            <NetworkDetection>
                <Router history={history}>
                    <Navigation/>
                </Router>
                <Container fluid>
                    <ErrorBoundary>
                        <Router history={history}>
                            <Switch>
                                {
                                    RouteConfig.map(
                                        (route, id) => {
                                            if (!route.public) {
                                                return <PrivateRoute
                                                    key={`route_${id}`}
                                                    exact
                                                    path={route.path}
                                                    component={route.component}/>
                                            } else {
                                                return <Route
                                                    key={`route_${id}`}
                                                    exact
                                                    path={route.path}
                                                    component={route.component}/>
                                            }
                                        }
                                    )
                                }
                                <Route component={NotFound}/>
                            </Switch>
                        </Router>
                    </ErrorBoundary>
                </Container>
            </NetworkDetection>
        )
    }
}

